import styled from 'styled-components'
import { Advert as OAdvert } from '../Advert'

export const Advert = styled(OAdvert)`
  text-align: center;
  padding: 15px;
`

export const Wrapper = styled.div.attrs({
  role: 'region',
  'aria-label': 'SEO Content',
})`
  max-width: 880px;
  margin: auto;

  & h1:first-of-type {
    text-align: center;
  }

  & h1 {
    font-size: 36px;
  }

  & h2 {
    font-size: 30px;
  }

  & h3 {
    font-size: 24px;
  }

  & p {
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 10px;
    word-wrap: break-word;
  }

  & blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    font-size: 17.5px;
    border-left: 5px solid #eeeeee;
    box-sizing: border-box;
  }

  & hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eeeeee;
    box-sizing: content-box;
    height: 0;
  }

  & .hangingindent {
    padding-left: 22px;
    text-indent: -22px;
  }

  & img {
    width: 100%;
  }

  & ul,
  ol {
    padding-left: 40px;
    padding-bottom: 10px;
  }

  & ul {
    list-style-type: disc;
    list-style-position: inside;
  }

  & ol {
    list-style-type: decimal;
    list-style-position: inside;
  }

  & ul ul,
  ol ul {
    list-style-type: circle;
    list-style-position: inside;
  }

  & ol ol,
  ul ol {
    list-style-type: decimal;
    list-style-position: inside;
  }

  & li {
    padding-bottom: 10px;
  }

  & a {
    color: #00799e;
  }

  & em {
    font-style: italic;
  }
`
